import React, { Component, PropTypes } from 'react';
import { Menu, Button, Modal, Spin, Select, Radio, Alert, Input, Form } from 'antd';

// import ClassSchedulesTab from './ClassSchedules';
// import ClassReviewsTab from './ClassReviews';
import { browserHistory } from 'react-router';

import { getContentProvinces, getContentDistricts } from 'data/content';

// import { getSchedule, getClassScheduleOrders, getScheduleRevenue, deleteSchedule } from 'redux/modules/schedule';
import { getSchedule, getClassScheduleOrders, getScheduleRevenue, deleteSchedule } from 'data/schedule';
import { getClassById, getRevenueSummariesByClassId } from 'data/class';
import { getServiceFee } from 'data/config';

import Utils from 'utils/utils';
import _ from 'lodash';
import moment from 'moment';

import classes from '../styles/ScheduleInfo.module.scss';

import ScheduleHeader from './ScheduleHeader';
import ScheduleInfoTab from './ScheduleInfoTab';
import ScheduleStudentsTab from './ScheduleStudents';
import ScheduleRevenueTab from './ScheduleRevenue';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option, OptGroup } = Select;

const TABS = [
  { label: 'Info', value: 'info' },
  { label: 'Students', value: 'students' },
  { label: 'Revenue', value: 'revenue' },
];
const TABS_WITHOUT_REVENUE = [
  { label: 'Info', value: 'info' },
  { label: 'Students', value: 'students' },
];
const Confirm = Modal.confirm;

// @asyncConnect([
//   {
//     promise: ({ store: { dispatch }, params: { classId, scheduleId } }) => {
//       const promises = [];
//       promises.push(dispatch(getSchedule(scheduleId)));
//       promises.push(dispatch(getClassById(classId)));
//       promises.push(dispatch(getContentProvinces()));
//       promises.push(dispatch(getContentDistricts('bangkok')));

//       promises.push(dispatch(getClassScheduleOrders(classId, scheduleId)));
//       promises.push(dispatch(getScheduleRevenue(scheduleId)));
//       promises.push(dispatch(getServiceFee()));

//       return Promise.all(promises);
//     },
//   },
// ])
// @connect(
//   (state) => ({
//     // pages: state.content.pages,
//     schedule: state.schedule.schedule,
//     orderResults: state.schedule.orders,
//     classroom: state.classroom.classDetail,
//     provinces: state.content.contentProvinces,
//     serviceFeeLevel: state.config.serviceFee,
//     revenue: state.schedule.revenueSummary,
//   }),
//   { getClassScheduleOrders, deleteSchedule, getSchedule, getContentDistricts },
// )
// @Form.create()
class ScheduleInfo extends Component {
  // static propTypes = {
  //   schedule: PropTypes.any,
  //   BreadCrumb: PropTypes.any,
  //   classroom: PropTypes.any,
  //   revenue: PropTypes.any,
  //   loading: PropTypes.bool,
  //   location: PropTypes.any,
  //   form: PropTypes.any,
  // };

  constructor(props) {
    super(props);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.onChangeFocusTab = this.onChangeFocusTab.bind(this);
    moment.locale('th');

    // props.getAutocompleteTeachers(props.classroom.owner.displayName);
    if (browserHistory) {
      this.backListener = browserHistory.listen((location) => {
        if (location.action === 'POP') {
          this.setState({ selectedTab: location.query.selectedTab ? location.query.selectedTab : 'info' });
        }
      });
    }

    this.state = {
      collapseMobile: [],
      mode: 'editor',
      selectedTab: props.location.query.selectedTab ? props.location.query.selectedTab : 'info',
      studentSortBy: '',
    };
  }
  componentDidMount = async () => {
    const scheduleId = this.props.params.scheduleId;
    const classId = this.props.params.classId;
    this.setState({ loading: true });

    const [schedule, tpClass, provinces, districts, orders, serviceFees, revenue] = await Promise.all([
      getSchedule(scheduleId),
      getClassById(classId),
      getContentProvinces(),
      getContentDistricts('bangkok'),
      getClassScheduleOrders(classId, scheduleId),
      getServiceFee(),
      getScheduleRevenue(scheduleId),
    ]);
    // const  = await ;
    // const  = await ;
    // const  = await
    // const  = await
    // const  = await
    // const  = await
    // const  = await
    this.setState({
      loading: false,

      schedule,
      classroom: tpClass,
      provinces,
      districts,
      orders,
      serviceFees,
      revenue,
    });
    window.scrollTo(0, 0);
  };

  componentWillUnmount() {
    this.backListener();
  }

  onToggleMode() {
    const mode = this.state.mode === 'editor' ? 'preview' : 'editor';
    this.setState({
      mode,
    });
  }

  onEditorStateChange(editorState, key) {
    this.setState({
      [key]: editorState,
    });
  }
  onChangeFocusTab(tab) {
    this.setState({ selectedTab: tab.key });
    browserHistory.push(`${this.props.location.pathname}?selectedTab=${tab.key}`);
  }

  showLoading = () => {
    this.setState({ loading: true });
  };
  hideLoading = () => {
    this.setState({ loading: false });
  };

  reloadSchedule = async () => {
    const scheduleId = this.props.params.scheduleId;
    this.setState({ loading: true });
    const schedule = await getSchedule(scheduleId);
    this.setState({ schedule, loading: false });
  };

  onStudentTableChange = (a, b, sorter) => {
    const updateStudentList = async () => {
      const classId = this.state.classroom._id;
      const scheduleId = this.state.schedule._id;

      this.setState({ loading: true });
      const orders = await getClassScheduleOrders(classId, scheduleId, { sortBy: this.state.studentSortBy });
      this.setState({
        loading: false,
        orders,
      });
    };

    const { field, order } = sorter;
    if (order === 'descend') {
      this.setState({ studentSortBy: `-${field}` }, updateStudentList);
    } else if (order === 'ascend') {
      this.setState({ studentSortBy: field }, updateStudentList);
    }
  };
  showCancelConfirm = () => {
    Confirm({
      title: 'Do you want to confirm?',
      // content: content || '',
      onOk: async () => {
        const id = this.state.schedule._id;

        this.setState({ loading: true });
        await deleteSchedule(id);
        const schedule = await getSchedule(id);
        this.setState({
          loading: false,
          schedule,
        });
      },
      // onCancel: this.onCancel,
    });
  };
  renderTabs() {
    const isRenderRevenue = !_.isEmpty(this.state.revenue);
    const renderedTabs = isRenderRevenue ? TABS : TABS_WITHOUT_REVENUE;
    return (
      <Menu onClick={this.onChangeFocusTab} selectedKeys={[this.state.selectedTab]} mode="horizontal">
        {renderedTabs.map((tab) => (
          <Menu.Item key={tab.value} className={classes.menuItem}>
            <div>{tab.label}</div>
          </Menu.Item>
        ))}
      </Menu>
    );
  }

  render() {
    // console.log(this.state.files);
    const { schedule, loading } = this.state;

    if (!schedule) {
      return <div></div>;
    }

    return (
      <div>
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <div className="page-header">
            {this.props.BreadCrumb}
            <ScheduleHeader classroom={this.state.classroom} serviceFeeLevel={this.state.serviceFees} schedule={schedule} Tabs={this.renderTabs()} onOpenCancelModal={() => this.showCancelConfirm()} />
          </div>
          {this.state.selectedTab === 'info' && (
            <ScheduleInfoTab {...this.props} {...this.state} schedule={schedule} reloadSchedule={this.reloadSchedule} showLoading={this.showLoading} hideLoading={this.hideLoading} />
          )}
          {this.state.selectedTab === 'students' && <ScheduleStudentsTab {...this.props} schedule={schedule} orders={_.get(this, 'state.orders.results') || []} onChange={this.onStudentTableChange} />}
          {this.state.selectedTab === 'revenue' && <ScheduleRevenueTab {...this.props} schedule={schedule} revenue={this.state.revenue} />}
        </Spin>
      </div>
    );
  }
}

export default ScheduleInfo;
